import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api';
import type { CurrentUserDto } from '../lib/types';

export function useCurrentUser() {
  return useQuery({
    queryKey: ['me'],
    queryFn: () => apiClient.get<CurrentUserDto>('/api/auth/me'),
    staleTime: 60_000
  });
}
